import { render, staticRenderFns } from "./AccountAlert.vue?vue&type=template&id=183e3886&scoped=true"
import script from "./AccountAlert.vue?vue&type=script&lang=ts"
export * from "./AccountAlert.vue?vue&type=script&lang=ts"
import style0 from "./AccountAlert.vue?vue&type=style&index=0&id=183e3886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e3886",
  null
  
)

export default component.exports